import { Injectable } from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { InspectionRowViewModel, InspectionSearchResultsCount, InspectionSearchRequest, OrderInspectionBy, InspectionData} from '../models/find-inspection.model';
import { SearchItem } from '../../../entities';
import { ImplementInspectionSearchRequest, ImplementInspectionSearchResult, SearchImplementInspectionItem } from '../../GET_NEW_UI/search-inspection/search-inspection.model';

@Injectable()
export class FindInspectionService {

  constructor(private _http: HttpClient) { }

  public getRepairEstimates(pageNumber: number, inspectionsPerPage: number, params: SearchItem[], orderBy: OrderInspectionBy): Observable<InspectionSearchResultsCount> {
    const body = new InspectionSearchRequest(pageNumber, inspectionsPerPage, params, orderBy);
    return this._http.post<InspectionSearchResultsCount>('api/findinspection/getrepairestimates', body).pipe(catchError(this.handleError));
  }

  public getAllRepairEstimates(pageNumber: number, inspectionsPerPage: number, params: SearchItem[], orderBy: OrderInspectionBy): Observable<InspectionSearchResultsCount> {
    const body = new InspectionSearchRequest(pageNumber, inspectionsPerPage, params, orderBy);
    return this._http.post<InspectionSearchResultsCount>('api/findinspection/GetAllRepairEstimates', body).pipe(catchError(this.handleError));
  }

  public getTemperatureInspections(pageNumber: number, inspectionsPerPage: number, params: SearchItem[], orderBy: OrderInspectionBy): Observable<InspectionSearchResultsCount> {
    const body = new InspectionSearchRequest(pageNumber, inspectionsPerPage, params, orderBy);
    return this._http.post<InspectionSearchResultsCount>('api/findinspection/GetAllTemperatureInspections', body).pipe(catchError(this.handleError));
  }
  public getThermographyInspections(pageNumber: number, inspectionsPerPage: number, params: SearchItem[], orderBy: OrderInspectionBy): Observable<InspectionSearchResultsCount> {
    const body = new InspectionSearchRequest(pageNumber, inspectionsPerPage, params, orderBy);
    return this._http.post<InspectionSearchResultsCount>('api/findinspection/GetAllThermographyInspections', body).pipe(catchError(this.handleError));
  }

  public getRepairEstimateRow(inspectionId: number): Observable<InspectionRowViewModel> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<InspectionRowViewModel>('api/findinspection/getrepairestimaterow', options).pipe(catchError(this.handleError));
  }

  public getTemperatureInspectionRow(inspectionId: number): Observable<InspectionRowViewModel> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<InspectionRowViewModel>('api/findinspection/getemperatureInspectionrow', options).pipe(catchError(this.handleError));
  }

  public getThermographyInspectionRow(inspectionId: number): Observable<InspectionRowViewModel> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<InspectionRowViewModel>('api/findinspection/gethermographyInspectionrow', options).pipe(catchError(this.handleError));
  }

  public getUnsyncedInspections(pageNumber: number, inspectionsPerPage: number, params: SearchItem[], orderBy: OrderInspectionBy): Observable<InspectionSearchResultsCount> {
    const body = new InspectionSearchRequest(pageNumber, inspectionsPerPage, params, orderBy);
    return this._http.post<InspectionSearchResultsCount>('api/findinspection/GetAllUnsyncedInspections', body).pipe(catchError(this.handleError));
  }

  public getUnsyncedInspectionRow(inspectionId: number): Observable<InspectionRowViewModel> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<InspectionRowViewModel>('api/findinspection/getunsyncedinspectionrow', options).pipe(catchError(this.handleError));
  }

  public getInspections(pageNumber: number, inspectionsPerPage: number, params: SearchItem[], orderBy: OrderInspectionBy, Ischecked: boolean): Observable<InspectionData> {
    const body = new InspectionSearchRequest(pageNumber, inspectionsPerPage, params, orderBy, Ischecked);
    return this._http.post<InspectionData>('api/findinspection/getinspections', body).pipe(catchError(this.handleError));
  }

  public getInspectionRow(inspectionId: number): Observable<InspectionRowViewModel> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<InspectionRowViewModel>('api/findinspection/getinspectionrow', options).pipe(catchError(this.handleError));
  }

// Awaiting Interpretations
  public getAllAwaitingInspections(pageNumber: number, inspectionsPerPage: number, searchItems: SearchItem[],  orderBy: OrderInspectionBy, Ischeck: boolean): Observable<InspectionData> {
    const body = new InspectionSearchRequest(pageNumber, inspectionsPerPage, searchItems, orderBy , Ischeck);
    return this._http.post<InspectionData>('api/findinspection/getAllAwaitingInspections', body).pipe(catchError(this.handleError));
  }

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error || 'Server error');
  }

  public getImplementInspections(pageNumber: number, inspectionsPerPage: number, SearchItems: SearchImplementInspectionItem, orderBy: OrderInspectionBy, Ischecked: boolean): Observable<ImplementInspectionSearchResult> {
   
    const body = new ImplementInspectionSearchRequest(pageNumber, inspectionsPerPage, SearchItems, orderBy);
    return this._http.post<ImplementInspectionSearchResult>('api/findinspection/getimplementinspections', body).pipe(catchError(this.handleError));
  }
}
